import { theme } from '@app/styles/theme'
import { css } from '@emotion/react'

export const formRoot = css`
  width: 100%;
  min-height: 100%;
`

export const formStack = css`
  gap: 0;
`

export const fieldsSection = css`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 24px;
  background: ${theme.palette.background.default};

  @media (max-width: 600px) {
    padding: 16px;
    gap: 16px;
  }
`

export const section = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  border: 1px solid ${theme.palette.neutral.light};
  border-radius: 14px;
  background: ${theme.palette.background.paper};
`

export const sectionLabel = css`
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${theme.palette.text.secondary};
`

export const fieldsGrid = css`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export const fullWidthField = css`
  grid-column: 1 / -1;
`

export const fieldControl = css`
  .MuiInputLabel-root {
    font-weight: 500;
  }

  .MuiOutlinedInput-root {
    min-height: 40px;
    border-radius: 10px;
    background: ${theme.palette.background.default};
  }

  .MuiOutlinedInput-input {
    font-size: 0.92rem;
  }
`

export const multilineField = css`
  .MuiInputLabel-root {
    font-weight: 500;
  }

  .MuiOutlinedInput-root {
    align-items: flex-start;
    padding: 0;
    border-radius: 12px;
    background: ${theme.palette.background.default};
  }

  .MuiOutlinedInput-inputMultiline {
    padding: 14px 16px;
    font-size: 0.92rem;
    line-height: 1.6;
  }
`

export const divider = css`
  display: none;
`

export const sourceLinksStack = css`
  gap: 12px;
`

export const sourceLinkRow = css`
  display: grid;
  grid-template-columns: minmax(160px, 0.8fr) minmax(240px, 1.4fr) 36px;
  gap: 10px;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export const deleteButton = css`
  width: 36px;
  height: 36px;
  margin-top: 2px;
  border: 1px solid ${theme.palette.neutral.light};
  border-radius: 10px;
  color: ${theme.palette.text.secondary};
  background: ${theme.palette.background.default};

  &:hover {
    color: ${theme.palette.error.main};
    border-color: ${theme.palette.error.light};
    background: ${theme.palette.action.hover};
  }

  @media (max-width: 900px) {
    justify-self: flex-start;
    margin-top: 0;
  }
`

export const addSourceButton = css`
  align-self: flex-start;
  margin-top: 2px;
  border-radius: 10px;
  text-transform: none;
  font-weight: 500;
`

export const actionsRow = css`
  position: sticky;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 6px -24px -24px;
  padding: 16px 24px;
  border-top: 1px solid ${theme.palette.neutral.light};
  background: ${theme.palette.background.paper};

  @media (max-width: 600px) {
    margin: 4px -16px -16px;
    padding: 14px 16px;
  }
`

export const submitButton = css`
  min-width: 156px;
  padding: 9px 16px;
  border-radius: 10px;
  text-transform: none;
  font-weight: 600;
  box-shadow: none;

  &:hover {
    box-shadow: none;
  }

  &:disabled {
    background: ${theme.palette.action.disabledBackground};
    color: ${theme.palette.action.disabled};
  }
`
